<div class="container-fluid" style="margin-bottom : 3rem;">

    <div class="card ">
        <router-outlet></router-outlet>
    </div>

</div>